import React, { useState, useEffect } from 'react';
import { Table, Card, Input, Select, Button, Tag, Space, DatePicker } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { getLoginLogs } from '../../api/admin';

const { Option } = Select;

const LoginLog = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ page: 1, size: 20, keyword: '', status: '' });

  const fetchLogs = async (p = params) => {
    setLoading(true);
    try {
      const res = await getLoginLogs(p);
      if (res.code === 200) {
        setLogs(res.data.logs);
        setTotal(res.data.total);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, []);

  const handleSearch = () => {
    const newParams = { ...params, page: 1 };
    setParams(newParams);
    fetchLogs(newParams);
  };

  const handleReset = () => {
    const newParams = { page: 1, size: 20, keyword: '', status: '' };
    setParams(newParams);
    fetchLogs(newParams);
  };

  const columns = [
    {
      title: '序号',
      key: 'index',
      width: 60,
      render: (_, __, idx) => (params.page - 1) * params.size + idx + 1
    },
    {
      title: '工号',
      dataIndex: 'employee_id',
      key: 'employee_id',
      width: 100
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      width: 90
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
      width: 80,
      render: (role) => role === 'admin'
        ? <Tag color="purple">管理员</Tag>
        : <Tag color="blue">学员</Tag>
    },
    {
      title: 'IP地址',
      dataIndex: 'ip',
      key: 'ip',
      width: 140
    },
    {
      title: '登录设备',
      dataIndex: 'device',
      key: 'device',
      width: 180,
      render: (v) => v || '-'
    },
    {
      title: '网络类型',
      dataIndex: 'network_type',
      key: 'network_type',
      width: 90,
      render: (v) => {
        if (!v || v === 'unknown') return '-';
        const map = {
          'wifi': 'WiFi',
          '4g': '4G',
          '5g': '5G',
          '3g': '3G',
          '2g': '2G'
        };
        return map[v] || v.toUpperCase();
      }
    },
    {
      title: '登录状态',
      dataIndex: 'status',
      key: 'status',
      width: 90,
      render: (status) => status === 'success'
        ? <Tag color="success">成功</Tag>
        : <Tag color="error">失败</Tag>
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: 100
    },
    {
      title: '登录时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 170,
      render: (v) => v ? new Date(v).toLocaleString('zh-CN') : '-'
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Space wrap>
          <Input
            placeholder="搜索工号/姓名"
            prefix={<SearchOutlined />}
            value={params.keyword}
            onChange={e => setParams({ ...params, keyword: e.target.value })}
            onPressEnter={handleSearch}
            style={{ width: 180 }}
          />
          <Select
            placeholder="登录状态"
            value={params.status || undefined}
            onChange={v => setParams({ ...params, status: v || '' })}
            allowClear
            style={{ width: 120 }}
          >
            <Option value="success">成功</Option>
            <Option value="fail">失败</Option>
          </Select>
          <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
          <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
        </Space>
      </div>

      <Card>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={logs}
          loading={loading}
          pagination={{
            current: params.page,
            pageSize: params.size,
            total,
            showSizeChanger: true,
            showTotal: t => `共 ${t} 条`,
            onChange: (page, size) => {
              const newParams = { ...params, page, size };
              setParams(newParams);
              fetchLogs(newParams);
            }
          }}
          scroll={{ x: 800 }}
        />
      </Card>
    </div>
  );
};

export default LoginLog;
